import React from 'react'
import intersperse from '../functions/intersperse'
import Translation from '../General/Translation'


const Genres = ({genres, translation, theme}) => {
    if(genres && genres[0]) {
        const interspersedGenres = intersperse(genres, ', ')

        if(theme === 'Arthouse') {
            return <p className="text-light genres">{interspersedGenres}</p>
        } else {
            return <p className="text-light genres"><span className="typo-color-muted"><Translation id="genres" trans={translation}>Genres</Translation>: </span>{interspersedGenres}</p>
        }
    } else {
        return ''
    }
}



export default Genres